import React from 'react';

export const ONETRUST_CONSENT_READY_EVENT_NAME = 'ONETRUST_CONSENT_READY';
export const UPDATE_FEATURE_TOGGLE_EVENT_NAME = 'UPDATE_FEATURE_TOGGLES';

interface QueuedEvent {
    eventId: string;
    data: Object;
}

export interface OnetrustActiveGroups {
    OnetrustActiveGroups: string;
}

export enum FeatureTogglesActions {
    ON = 'ON',
    OFF = 'OFF',
}

export interface FeatureTogglePayload {
    name: string;
    action: FeatureTogglesActions;
}

const WestwingEventHandler = () => {
    const queue: QueuedEvent[] = [];

    const subscribers = {};

    const publish = (eventId: string, data: Object) => {
        queue.push({ eventId, data });
        if (!subscribers[eventId]) {
            return;
        }
        subscribers[eventId].forEach((subscriberCallback: Function) => subscriberCallback(data));
    };

    const subscribe = (eventId: string, callback: Function) => {
        if (!subscribers[eventId]) {
            subscribers[eventId] = [];
        }
        const index = subscribers[eventId].push(callback) - 1;

        const queuedEvent = queue.find(event => event.eventId === eventId);
        if (queuedEvent) {
            callback(queuedEvent.data);
        }
        return {
            unsubscribe: () => {
                subscribers[eventId].splice(index, 1);
            },
        };
    };

    const events = {
        queue,
        subscribers,
        subscribe,
        publish,
    };

    const initWindow = () => {
        window.ww.events = events;
    };

    return { events, initWindow };
};

const toScript = () => {
    return (
        <script
            type="text/javascript"
            dangerouslySetInnerHTML={{ __html: `(${WestwingEventHandler.toString()})().initWindow()` }}
        />
    );
};

export const oneTrustConsentEventDataParser = (onetrustActiveGroups?: OnetrustActiveGroups) => {
    const OnetrustActiveGroups = onetrustActiveGroups ? onetrustActiveGroups.OnetrustActiveGroups : '';
    return {
        stricklyNecessaryCokkies: String(OnetrustActiveGroups).includes('C0001'),
        performenceCookies: String(OnetrustActiveGroups).includes('C0002'),
        functionalCookies: String(OnetrustActiveGroups).includes('C0003'),
        targetingCookies: String(OnetrustActiveGroups).includes('C0004'),
        socialMediaCookies: String(OnetrustActiveGroups).includes('C0005'),
        allGroups: OnetrustActiveGroups.split(',').map(groupString => groupString.split(':')[0]),
    };
};

export default { toScript, handler: WestwingEventHandler };
